import React, { useEffect } from 'react';
import { allBlogPosts } from '../blogData'; 
// We no longer need 'Link' from react-router-dom

function BlogPage() {

  useEffect(() => {
    document.title = "Blog - Techpack Creators";
    return () => {
      document.title = "Techpack Creators"; 
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 pt-32 pb-16 px-6 sm:px-10 lg:px-16">
      <div className="container mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold font-montserrat mb-12 text-center text-gray-900">
          Our Blog
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl w-full mx-auto">
          {allBlogPosts.map((blog, idx) => (
            
            // --- THIS IS THE UPDATED PART ---
            // We use a standard <a> tag with target="_blank"
            <a 
              href={`/blog/${blog.slug}`} 
              key={idx} 
              className="block"
              target="_blank"
              rel="noopener noreferrer"
            >
            {/* --- END OF UPDATED PART --- */}

              <div
                className="bg-white shadow-lg rounded-2xl overflow-hidden hover:scale-105 transform transition duration-500 ease-in-out flex flex-col h-full"
              >
                {/* Image */}
                <div className="w-full aspect-square">
                  <img
                    src={blog.img}
                    alt={blog.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Content */}
                <div className="p-4 sm:p-6 flex flex-col justify-between flex-1">
                  <h3 className="text-lg sm:text-xl font-montserrat mb-2 sm:mb-3 text-gray-900">
                    {blog.title}
                  </h3>
                  <p className="text-gray-600 font-montserrat text-sm sm:text-base">
                    {blog.description}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BlogPage;